import http from "../../http-common";
import httpMulipart from "../../http-multipart";
import httpMultipart from "../../http-multipart";
import httpFile from "@/http-multipart";

class EmployeeDataService {
    searchEmployeeInSchool(pageNumber, maxPageItem, loginStatus, statusEmployeee, idDepartment, employeeNameOrPhone) {
        return http.get(`/employees/search?pageNumber=${pageNumber}&maxPageItem=${maxPageItem}&loginStatus=${loginStatus}&employeeStatus=${statusEmployeee}&idDepartment=${idDepartment}&employeeNameOrPhone=${employeeNameOrPhone}`)
    }

    searchEmployeesForKpi(pageNumber, maxPageItem, employeeStatus) {
        return http.get('/employees/search', {
            params: { pageNumber, maxPageItem, employeeStatus }
        });
    }

    getEmployeeStatus() {
        return http.get(`/employees/employee-status`);
    }

    getAccountType() {
        return http.get(`/common-data/account-type`);
    }

    getEmployeeById(id) {
        return http.get(`/employees/${id}`);
    }

    getEmployeeByIdAndIdSchool(id, idSchool) {
        return http.get(`/employees/school/${id}/?idSchool=${idSchool}`);
    }

    getTabDepartmentInEmployeeService() {
        return http.get(`/employees/tab-department`);
    }

    getTabDepartmentInEmployeeById(idEmployee) {
        return http.get(`/employees/tab-department/${idEmployee}`);
    }

    getTabProfessionalInEmployee() {
        return http.get(`/employees/tab-professional`);
    }

    getTabProfessionalInEmployeeById(idEmployee) {
        return http.get(`/employees/tab-professional/${idEmployee}`);
    }

    getSubjectInClassByIdClass(idClass) {
        return http.get(`/employees/subject-in-class/${idClass}`);
    }

    createTeacher(formData) {
        return http.post("/employees", formData);
    }

    createExcelTeacher(dataList) {
        return http.post("/employees/import-excel-employee-new", dataList);
    }

    uploadAvatar(formData) {
        return httpMulipart.post("/employees/insert-avatar", formData);
    }

    uploadQrBank(formData) {
        return httpMulipart.post("/employees/insert-Update-qrBank", formData);
    }

    uploadEditAvatar(formData) {
        return httpMulipart.post("/employees/edit-avatar", formData);
    }

    uploadEditQrBank(formData) {
        return httpMulipart.post("/employees/edit-qrBank", formData)
    }

    update(id, data) {
        return http.put(`/employees/${id}`, data);
    }

    updateActiveOne(data) {
        return http.put(`/employees/update/active-one`, data);
    }

    updateActiveMany(data) {
        return http.put(`/employees/update/active-many`, data);
    }

    updateActiveManySMS(data) {
        return http.put(`/employees/update/active-many/sms-receive`, data);
    }

    updateActiveOneSMSReceive(data) {
        return http.put(`/employees/update/active-one/sms-receive`, data);
    }

    updateMultiEmployeeActivated(data) {
        return http.put(`/employees/multi-employee-activate`, data);
    }

    updateMultiEmployeeUnActivated(data) {
        return http.put(`/employees/multi-employee-unactivate`, data);
    }

    delete(id) {
        return http.delete(`employees/${id}`);
    }

    deleteMulti(data) {
        return http.put(`/employees/delete-multi`, data)
    }

    findIconTeacherCreate() {
        return http.get(`/employees/icon-teacher-create`);
    }

    // findIconPlusCreate() {
    //   return http.get(`/common-data/icon-plus-create`);
    // }
    //bỏ
    findIconPlusNotifyCreate() {
        return http.get(`/employees/icon-plus-notify-create`);
    }

    findIconTeacherUpdate(id) {
        return http.get(`/employees/icon-teacher-update/${id}`);
    }

    findIconNotifyPlusUpdate(id) {
        return http.get(`/employees/icon-plus-notify-update/${id}`);
    }

    findAllByDepartment(id) {
        return http.post(`/employees/export-excel/${id}`, {responseType: 'blob'});
    }

    //create Notify
    createdNotifyEmployee(data) {
        return httpMultipart.post(`/employees/employee-notify`, data);
    }

    //khoong dung nua
    createdNotifySmsEmployee(data) {
        return http.post(`/schedulesms/employee-sms`, data);
    }

    createdNotifySmsEmployeeNew(data) {
        return http.post(`/employees/employee-sms`, data);
    }

    //gửi sms mới
    createEmployeeSms(data) {
        return http.post("/employees/sms", data);
    }

    sendAccountEmployee(data) {
        return http.post(`/employees/sms/account`, data);
    }

    updateEmployeeStatus(data) {
        return http.put("/employees/employee-status", data);
    }

    //Export excel
    exportExcelEmployeeNew(list) {
        return http.get(`employees/export-excel/employee-new?list=${list}`)
    }

    exportExcelDepartmentNew(idDepartment) {
        return http.get(`employees/export-excel/employee-new?idDepartment=${idDepartment}`)
    }

    getListCamera(idEmployee, typeUser) {
        return http.get(`config/camera/get-full-cam/teacher?idTeacher=${idEmployee}&typeUser=${typeUser}`);
    }

    getInfoConfigCamera(idCamera, idEmployee, typeUser) {
        return http.get(`config/camera/plus?idCamera=${idCamera}&idUser=${idEmployee}&typeUser=${typeUser}`);
    }

    saveSettingCameraPlus(data) {
        return http.post(`config/camera/save-setting-camera/plus`, data);
    }

    saveConfigCamera(data) {
        return http.post(`config/camera/save-config-camera`, data);
    }

    findAllAppIconTeacherForSchool() {
        return http.get(`/employees/findAllAppIconTeacherForSchool`)
    }

    updateAppIconForManyTeacher(data) {
        return http.put(`/employees/updateAppIconForManyTeacher`, data);
    }

    /**
     * api lọc NS theo id phòng ban (không phân trang)
     *
     * @param {Object} params
     * @param {Number} params.idDepartment - id phòng ban
     * */
    getEmployeesByDepartment(params) {
        return http.get("/employees/listTeacherAppIcon", {
            params: params
        })
    }

    /**
     * Lấy thông tin thiết bị
     */
    getListDeviceRecognition(){
        return http.get(`/recognition/device`)
    }

    getUserRecognition(idUser,idDevice,typeAccount){
        return http.get(`/recognition/detail`, {params: {idUser,idDevice,typeAccount}})
    }

    addUserToManyDevice(formData) {
        return httpFile.post(`/recognition/addUserToManyDevice`, formData);
    }
    updateUserToManyDevice(formData) {
        return httpFile.post(`/recognition/updateUserToManyDevice`, formData);
    }

    deleteDataRecognition(id) {
        return http.delete(`/recognition/delete/${id}`);
    }


    getInformationFinger(idDevice, fingerNo) {
        return http.get(`/recognition/finger`, {params: {idDevice, fingerNo}});
    }

    getInformationNumberCard(idDevice){
        return http.get(`/recognition/read-card`, {params: {idDevice}});
    }


    searchConfigRoleUserChatEmployee(page, limit, appType, search) {
        return http.get(`/employees/configRoleUserChat/search?page=${page}&limit=${limit}&appType=${appType}&search=${search}`)
    }

    updateForManyTeacher(data) {
        return http.put(`/employees/configRoleUserChat/updateForManyTeacher`, data);
    }


}

export default new EmployeeDataService();
